// eslint-disable-next-line import/prefer-default-export
export const mapStyles = {
  border: '1px solid #e0e0e0',
  width: '100%',
  height: '800px',
  borderRadius: '4px',
  marginBottom: '25px',
};
